'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _Item = require('./Item');

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$Tilemap) {
  _inherits(_class, _Phaser$Tilemap);

  function _class(_ref) {
    var game = _ref.game,
        asset = _ref.asset;

    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, game, asset));

    _this.asset = asset;

    for (var i in _this.tilesets) {
      key = _this.tilesets[i].name;
      _this.addTilesetImage(key);
    }

    // load all tile layers
    _this.layerMap = {};
    _this.boundaries = [];
    _this.water = [];
    var spriteLayerName = "";
    if (_this.properties && _this.properties.spriteLayer) var spriteLayerName = _this.properties.spriteLayer;
    for (var i in _this.layers) {
      var info = _this.layers[i];
      var name = info.name;
      var layer = _this.createLayer(info.name);
      if (info.properties.collides) {
        _this.setCollisionBetween(1, 2000, true, name);
        _this.boundaries.push(layer);
      } else if (info.properties.water) {
        _this.setCollisionBetween(1, 2000, true, name);
        _this.water.push(layer);
      }
      layer.alpha = info.alpha;
      layer.resizeWorld();
      _this.layerMap[info.name] = layer;
      if (name == spriteLayerName) {
        _this.spriteLayer = _this.game.add.group();
      }
    }
    if (_this.spriteLayer == null) _this.spriteLayer = _this.game.add.group();

    // load all objects
    _this.triggers = [];
    _this.objectGroup = _this.game.add.group();
    _this.objectMap = {};
    _this.allObjects = [];
    for (var key in _this.objects) {
      for (var obj in _this.objects[key]) {
        var props = _this.objects[key][obj];
        _this.objectMap[props.name] = props;
        _this.allObjects.push(props);
        var sprite = _this.objectGroup.create(props.x, props.y, null);
        _this.game.physics.enable(sprite, _phaser2.default.Physics.ARCADE);
        sprite.body.setSize(props.width, props.height, 0, 0);
        sprite.props = props;
        _this.triggers.push(sprite);
      }
    }
    return _this;
  }

  _createClass(_class, [{
    key: 'update',
    value: function update() {}
  }]);

  return _class;
}(_phaser2.default.Tilemap);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/sprites/Level.js
// module id = 124
// module chunks = 0